import { RootState } from "../../store";

export const getUserHistory = (state: RootState) => state.getHistory;
